import Vue from 'vue'
import utils from "@/components/tools/utils.js";
import dHttps from '@/components/tools/request/https-d.js';

/**
 * 授课vuex
 */
const state = {
    khzyFsId: '',                   // 授课一组习题发送ID
    tableSubId: '',                 // 表格子题ID
    exerciseSubId:'',               // 试题子题id
    clazzId:'',                     // 当前班级ID
    exerArr:[],                     // 授课一组习题
    cIndex: 0,                      // 当前试题的index
    cExerObj: {exercise:{},picList:[]},        // 当前试题obj(暂不使用)
    itemStuNumObj: [],              // 学生答对答错人数统计
    showAnswerType: '',             // 'correct'、'student'
    testModal:'',                   // 随堂测验弹出框：分析'analysis',表格附图'pic','elemAnalysis'
    showStunCorrectTitle: false,    // 分析里点击学生答案
    //showAnalysis: false,          // 是否显示分析
    //showTablePic: false,          // 是否显示凭证表格图片 showTablePic 和 showAnalysis 互斥，只能同时显示一个modal
    clazzSubmitNumArr: [{}],          // 每个班级的提交人数情况 TODO 可以多班授课的时候需要修改后台sql，查所有人不区分班级
    stuResultArr:[],                // 学生作答结果list, 得分排名
    stuResultTenArr:[],
    scoreRateArr: [],               // 得分率
    aveScoreArr:[],                 // 每道题的平均分
    stuExerObj:{exercise:{}},       // 某个学生的作答
}
const actions = {
    setKhzyFsId({ commit }, val){
        commit('SET_SEND_ID',val);
    },
    setTableSubId({ commit }, val){
        commit('SET_TABLE_SUB_ID',val);
    },
    setExerciseSubId({ commit }, val){
        commit('SET_EXERCISE_SUB_ID',val);
    },
    setClazzId({ commit }, val){
        commit('SET_CLAZZ_ID',val);
    },
    setExerArr({ commit }, arr){
        // 习题组更新时，默认显示第一道题
        commit('SET_EXER_ARR',arr);
        commit('SET_CINDEX',0);
    },
    setCIndex({ commit, state }, val){
        commit('SET_CINDEX',val);
        commit('SET_CURRENT_EXER_OBJ',state.exerArr[val]);
    },
    // setCurrentExerObj({ commit }, obj){
    //     commit('SET_CURRENT_EXER_OBJ',obj);
    // },
    setShowAnswerType({ commit }, val){
        val = val ? val:'';
        commit('SET_SHOW_ANSWER_TYPE',val);
    },
    listAnswerItemStuNum({ commit, state }) {
      let exerciseId = '';
      if(state.cExerObj.exercise.type === 9){
        exerciseId = state.tableSubId;
      } else if( state.cExerObj.exercise.type === 7){
          exerciseId = state.exerciseSubId;
      } else {
        exerciseId = state.cExerObj.exercise.id;
      }
      let param = {
        fsId: state.khzyFsId,                   // 课后作业发送ID
        exerciseId: exerciseId, // 试题ID
        type: state.cExerObj.exercise.type      // 试题类型：单选题
      };
      return dHttps.listAnswerItemStuNum(param).then(res => {
        if (utils.requestSuccess(res)) {
          commit('SET_STU_NUM_OBJ', res.data);
        }
      })
    },
    setStunCorrectTitle({ commit }, val){
        commit('SET_STU_CORRECT_TITLE',val);
    },
    setTestModal({ commit }, val){
        commit('SET_TEST_MODAL', val);
    },
    getClazzSubmitNumArr({ commit, state }, param){
        return dHttps.getKhzyFsCls({fsjlId: state.khzyFsId}).then(res => {
            if (utils.requestSuccess(res)) {
                if(res.data.length > 0) {
                    commit('SET_CLAZZ_SUBMIT_NUM_ARR',res.data);
                }
            }
        })
    },
    getStuResultArr({ commit, state}){
        let param = {
            khzyFsId: state.khzyFsId,
            classId: state.clazzId,
            orderBy: 1,
            sort: 'asc',
        }
        return dHttps.listKhzyFsStudent(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_STU_RESULT_ARR', res.data);
            }
        });
    },
    getTopTenArr({ commit, state}){
        let param = {
            khzyFsId: state.khzyFsId,
            classId: state.clazzId,
            orderBy: 2,
            sort: 'desc',
            pageSize: 10,
            pageNum: 1
        }
        return dHttps.listKhzyFsStudent(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_STU_RESULT_TEN_ARR', res.data);
            }
        });
    },
    getScoreRateArr({ commit, state}){
        let param = { khzyFsId: state.khzyFsId, classId: state.clazzId };
        return dHttps.listEachExerScoreRate(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_SCORE_RATE_ARR', res.data);
            }
        })
    },
    getAveScoreArr({ commit, state}){
        let param = { khzyFsId: state.khzyFsId, classId: state.clazzId };
        return dHttps.listEachExerAvgScore(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_AVE_SCORE_ARR', res.data);
            }
        })
    },
    getStuExerObj({ commit, state},data){
        let param = { fsjlId: state.khzyFsId, stuId: data.stuId, exerId: state.cExerObj.exercise.id};
        return dHttps.getStuAnswerOfExer(param).then(res => {
            if (utils.requestSuccess(res)) {
                commit('SET_STU_EXER_OBJ', res.data);
            }
        })
    }
}
const mutations = {
    ['SET_SEND_ID'](state, val) {
        Vue.set(state, 'khzyFsId', val);
    },
    ['SET_TABLE_SUB_ID'](state, val) {
        Vue.set(state, 'tableSubId', val);
    },
    ['SET_EXERCISE_SUB_ID'](state, val) {
        Vue.set(state, 'exerciseSubId', val);
    },
    ['SET_EXER_ARR'](state, arr) {
        Vue.set(state, 'exerArr', arr);
    },
    ['SET_CINDEX'](state, val) {
        Vue.set(state, 'cIndex', val);
    },
    ['SET_CURRENT_EXER_OBJ'](state, obj) {
        Vue.set(state, 'cExerObj', obj);
    },
    ['SET_SHOW_ANSWER_TYPE'](state, val) {
        Vue.set(state, 'showAnswerType', val);
    },
    ['SET_STU_NUM_OBJ'](state, arr){
        Vue.set(state, 'itemStuNumObj', arr);
    },
    ['SET_STU_CORRECT_TITLE'](state, val){
        Vue.set(state, 'showStunCorrectTitle', val);
    },
    ['SET_TEST_MODAL'](state, val){
        Vue.set(state, 'testModal', val);
    },
    ['SET_CLAZZ_SUBMIT_NUM_ARR'](state, arr){
        Vue.set(state, 'clazzSubmitNumArr', arr);
    },
    ['SET_STU_RESULT_ARR'](state, arr){
        Vue.set(state, 'stuResultArr', arr);
    },
    ['SET_STU_RESULT_TEN_ARR'](state, arr) {
        Vue.set(state, 'stuResultTenArr', arr);
    },
    ['SET_CLAZZ_ID'](state, val){
        Vue.set(state, 'clazzId', val);
    },
    ['SET_SCORE_RATE_ARR'](state, arr){
        Vue.set(state, 'scoreRateArr', arr);
    },
    ['SET_AVE_SCORE_ARR'](state, arr){
        Vue.set(state, 'aveScoreArr', arr);
    },
    ['SET_STU_EXER_OBJ'](state, obj){
        Vue.set(state, 'stuExerObj', obj);
    }
}

export default {
    state,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/e000201.js